import { useState, useEffect } from 'react';
import {
    Card, Table, TableBody, TableCell, Container, TableContainer, TableRow, TablePagination,
    Button, Modal, Box, Typography, Divider
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import Page from './../../components/Page';
import Scrollbar from './../../components/Scrollbar';
import { UserListHead } from '../../sections/@dashboard/user';
import HeaderBreadcrumbs from './../../components/HeaderBreadcrumbs';
import Loader from './../../components/Loader';
import { GetTDSListAction, ResetTDSListAction, GetWithDrawalListAction, WalletTransTDSAction } from 'src/redux/actions/TransactionsActions';
import moment from 'moment';
import { FetchUserDetailAction } from "src/redux/actions/UsersAction";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
};

export default function TDSManager() {
    const dispatch = useDispatch();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const { tds_list, trans_request, loading } = useSelector(state => state.transaction_manager)
    const [requestAction, setRequestAction] = useState({});
    const [childOpen, setChildOpen] = useState(false);
    const [open, setOpen] = useState(false);


    useEffect(() => {
        let data = { "atype": "bal_wtd_tds_pen" };
        dispatch(GetTDSListAction((page + 1), rowsPerPage, data))
        return () => dispatch(ResetTDSListAction())
    }, [dispatch, page, rowsPerPage])

    useEffect(() => {
        if (trans_request?.data?.status === true) {
            window.location.reload();
        }
    }, [trans_request])



    const handleChangePage = (_, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value));
        setPage(0);
    };

    const userDetailState = useSelector(
        (state) => state.users,
    );
    let userDetails = userDetailState?.user_detail?.data?.data;

    const onClickRequest = (e, userDetl, type) => {
        let sRequestAction = { ...requestAction, type: type }
        setRequestAction(sRequestAction);

        setChildOpen(true);

    }

    const handleClose = () => {
        setOpen(false);
    };

    const handleChildClose = () => {
        setChildOpen(false);
    }

    const onClickAssRequest = () => {
        console.log("requestAction", requestAction)
        dispatch(WalletTransTDSAction({ transId: requestAction.transId, type: requestAction.type }));
        handleChildClose();
        handleClose();
        //dispatch(GetWithDrawalListAction((page + 1), rowsPerPage));
    }

    const handleOpen = (e, id, amount, emailid, transId, value) => {
        setRequestAction({ transId, amount, emailid, value });
        dispatch(FetchUserDetailAction({ userid: id }));
        setOpen(true);
    };
    console.log("0000--->>", requestAction)
    return (<>
        <Page title="TDS Manager">

            {/* {loading? <Loader /> : null} */}

            <Container maxWidth="lg">
                <HeaderBreadcrumbs
                    heading="TDS Manager"
                    links={[
                        { name: 'Dashboard', href: "/dashboard/app" },
                        { name: 'TDS Manager' }
                    ]}
                // action={
                //     <Button onClick={() => handleDownload()} variant="contained">
                //         <Download />
                //         Download
                //     </Button>
                // }
                />
                <Card>
                    <Scrollbar>
                        <TableContainer sx={{ minWidth: 800 }}>
                            <Table>
                                <UserListHead
                                    rowCount={tds_list && tds_list?.data?.data?.total_count}
                                    headLabel={[
                                        { id: "c_no", label: "Sr no.", alignRight: false },
                                        // { id: 'txn_id', label: 'Match', alignRight: false },
                                        // { id: 'phone', label: 'Match Date', alignRight: false },
                                        { id: 'email', label: 'User Email', alignRight: false },
                                        { id: 'type', label: 'User Phone', alignRight: false },
                                        { id: 'mode', label: 'Request Amount', alignRight: false },
                                        // { id: 'txn_type', label: 'TDS Amount', alignRight: false },
                                        { id: 'date', label: 'Transaction Date', alignRight: false },
                                    ]}
                                />
                                <TableBody>
                                    {tds_list && tds_list?.data?.data?.Tds_list?.map((value, index) => {
                                        return (
                                            <TableRow hover key={index}>
                                                <TableCell component="th" scope="row">
                                                    {page * rowsPerPage + (index + 1)}.
                                                </TableCell>
                                                {/* <TableCell component="th" scope="row"> {value?.data[0]?.title ? value?.data[0]?.title : "-"} </TableCell>
                                                <TableCell component="th" scope="row">{value?.data[0]?.date_start ? moment(value?.data[0]?.date_start).format("DD/MM/YYYY") : "-"}</TableCell> */}
                                                <TableCell component="th" scope="row">{value?.email ? value?.email : "-"}</TableCell>
                                                <TableCell component="th" scope="row">{value?.phone ? value?.phone : "-"}</TableCell>
                                                <TableCell component="th" scope="row">{value?.amount ? value?.amount : "-"}</TableCell>
                                                {/* <TableCell component="th" scope="row">{value?.after_deduct_tds_amount ? value?.after_deduct_tds_amount : "-"}</TableCell> */}
                                                <TableCell component="th" scope="row">{value.transaction_date ? new Date(value.transaction_date * 1000).toUTCString().split("GMT")[0] : "-"}</TableCell>
                                                <TableCell component="th" scope="row"><Button onClick={(e) => handleOpen(e, value.userid, value?.amount, value.email, value.tid, value)}>Open modal</Button></TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Scrollbar>

                    <TablePagination
                        rowsPerPageOptions={[25, 50, 100, 150, 200]}
                        component="div"
                        count={tds_list && tds_list?.data?.data?.total_count}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Card>
            </Container>
        </Page>

        <Modal
            open={open}
            aria-labelledby="parent-modal-title"
            aria-describedby="parent-modal-description"
            style={{ overflowY: "scroll", maxHeight: "100vh" }}
        >

            <Box sx={style}>
                <Typography
                    id="modal-modal-title"
                    style={{ marginBottom: 20 }}
                    align={"center"}
                    variant="h6"
                    component="h2"
                > Bank Details </Typography>
                <Divider />

                <TableContainer fullWidth>
                    <Table>
                        <TableBody>
                            <TableCell>

                                <TableRow>
                                    <TableCell component="th" scope="row"> Name </TableCell>
                                    <TableCell align="left"> {userDetails?.user_profile?.name
                                        ? userDetails?.user_profile?.name
                                        : "--"}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row"> Email </TableCell>
                                    <TableCell align="left"> {userDetails && userDetails.email ? userDetails.email : "--"}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row"> Phone </TableCell>
                                    <TableCell align="left"> {userDetails && userDetails.phone ? userDetails.phone : "--"}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row"> Current Balance </TableCell>
                                    <TableCell align="left"> {userDetails && userDetails.walletbalance ? userDetails.walletbalance : "--"}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row"> Current Win Balance </TableCell>
                                    <TableCell align="left"> {userDetails && userDetails.wltwin ? userDetails.wltwin : "--"}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row"> Request Amount </TableCell>
                                    <TableCell align="left"> {requestAction.amount}</TableCell>
                                </TableRow>
                            </TableCell>
                            <TableCell>
                                <TableRow>
                                    <TableCell component="th" colspan='2' scope="row"> <h3><u> Bank Detail</u></h3> </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row"> Account Holder Name </TableCell>
                                    <TableCell align="left"> {userDetails?.userbank_account?.acholdername ? userDetails?.userbank_account?.acholdername : "-"} </TableCell>
                                </TableRow>

                                <TableRow>
                                    <TableCell component="th" scope="row"> Bank Name </TableCell>
                                    <TableCell align="left"> {userDetails?.userbank_account?.bankname ? userDetails?.userbank_account?.bankname : "-"} </TableCell>
                                </TableRow>

                                <TableRow>
                                    <TableCell component="th" scope="row"> Account Number </TableCell>
                                    <TableCell align="left"> {userDetails?.userbank_account?.acno ? userDetails?.userbank_account?.acno : "-"} </TableCell>
                                </TableRow>

                                <TableRow>
                                    <TableCell component="th" scope="row"> IFSC Code </TableCell>
                                    <TableCell align="left">  {userDetails?.userbank_account?.ifsccode ? userDetails?.userbank_account?.ifsccode : "-"} </TableCell>
                                </TableRow>

                                <TableRow>
                                    <TableCell component="th" scope="row"> Bank Image </TableCell>
                                    <TableCell align="left">
                                        <img src={userDetails?.userbank_account?.image ? userDetails?.userbank_account?.image : "/no_image.png"} className="img-fluid" alt={userDetails?.userbank_account?.acholdername} width="200" />
                                    </TableCell>
                                </TableRow>

                                <TableRow>
                                    <TableCell component="th" colspan='2' scope="row"> <h3><u> PAN Detail</u></h3> </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row"> Full Name </TableCell>
                                    <TableCell align="left"> {requestAction?.value?.user_pan?.full_name ? requestAction?.value?.user_pan?.full_name : "-"} </TableCell>
                                </TableRow>

                                <TableRow>
                                    <TableCell component="th" scope="row"> Bank Name </TableCell>
                                    <TableCell align="left"> {requestAction?.value?.user_pan?.pan_number ? requestAction?.value?.user_pan?.pan_number : "-"} </TableCell>
                                </TableRow>
                            </TableCell>
                        </TableBody>
                    </Table>
                </TableContainer>

                <div style={{ marginTop: 20, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <Button onClick={handleClose}>Close</Button>
                    {/* <Button variant="contained" color="error" onClick={(e)=>onClickRequest(e,userDetails,"decline")} style={{ marginLeft: 10 }} >Decline</Button> */}
                    <Button variant="contained" color="success" onClick={(e) => onClickRequest(e, userDetails, "accept")} style={{ marginLeft: 10 }}>Accept</Button>
                </div>


            </Box>

        </Modal>

        <Modal
            open={childOpen}
            aria-labelledby="child-modal-title"
            aria-describedby="child-modal-description"
        >
            <Box sx={{ ...style, width: 500 }}>
                <h2 id="child-modal-title">Are you sure, you want to {requestAction.type}?</h2>
                <p id="child-modal-description">
                    <TableContainer fullWidth>
                        <Table>
                            <TableBody>

                                <TableRow>
                                    <TableCell component="th" scope="row"> Email ID </TableCell>
                                    <TableCell align="left"> {requestAction.emailid}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row"> Request Amount </TableCell>
                                    <TableCell align="left"> {requestAction.amount}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </p>
                <div style={{ marginTop: 20, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <Button onClick={handleChildClose}>Close</Button>
                    <Button variant="contained" color={(requestAction.type === "accept") ? "success" : "error"} onClick={(e) => onClickAssRequest(e, userDetails, requestAction.type)}>{requestAction.type === "accept" ? "Accept" : "Decline"}</Button>
                </div>

            </Box>
        </Modal>
    </>);
}
